import { render, staticRenderFns } from "./JgBespokeCrash.vue?vue&type=template&id=186d6ebe&"
import script from "./JgBespokeCrash.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeCrash.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeCrash.vue?vue&type=style&index=0&id=186d6ebe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports